import {  put, select, call } from 'redux-saga/effects'
import { setLoading as setDynamicLoading } from '../../slices/dynamicElementsSlice'
import { toast } from 'react-toastify'
import { setPageTabData } from '../../slices/dynamicUiSlice'
import { deleteTabFromPage, patchDynamicUiPage, postOrPutPageTabs } from '../requests/pageService'


export function* handleAddOrUpdatePageTabs(action) {
  const element = 'editing'
  try {
    const { id, data } = action.payload
    yield put(setDynamicLoading({ loading: true, element }))
    const selectedPageId = yield select((state) => state.dynamicUi.pages.selectedPage)

    const isEdit = !!id
    const { data: resp } = yield call(() => postOrPutPageTabs(selectedPageId.substring(1), id, data))

    // yield delay(3000)

    if (isEdit) {

      //todo fetch following from response
      yield put(setPageTabData({ update: { ...resp } }))

      toast.success('Tab Updated Successfully')

    } else {

      yield put(setPageTabData({ active: true, add: { ...resp } }))

      toast.success('Tab Added Successfully.')
    }

  } catch (e) {
    const errorMsg = e.response ? e.response.data.message : e.message
    toast.error(`Error: ${errorMsg}`)
  } finally {
    yield put(setDynamicLoading({ loading: false, element }))
  }
}

export function* handleRemovePageTab(action) {
  const element = 'editing'
  try {
    yield put(setDynamicLoading({ loading: true, element }))
    const selectedTabId = yield select((state) => state.dynamicUi.pages.tabs.selected)
    const selectedPageId = yield select((state) => state.dynamicUi.pages.selectedPage)

    yield call(() => deleteTabFromPage(selectedPageId.substring(1), selectedTabId))


    // yield delay(3000)

    yield put(setPageTabData({ active: true, deleted: selectedTabId }))

    toast.success('Tab Deleted Successfully.')
  } catch (e) {
    const errorMsg = e.response ? e.response.data.message : e.message
    toast.error(`Error: ${errorMsg}`)
  } finally {
    yield put(setDynamicLoading({ loading: false, element }))
  }
}

export function* handleChangePageSettings(action) {
  const element = 'editing'
  try {
    const { active = false, isPinType = true } = action.payload
    yield put(setDynamicLoading({ loading: true, element }))
    const selectedPageId = yield select((state) => state.dynamicUi.pages.selectedPage)

    const data = isPinType ? {is_sticky_header: active} : {is_vertical: active}
    yield call(() => patchDynamicUiPage(selectedPageId.substring(1), data))

    yield put(setPageTabData(data))

    toast.success(isPinType ? `Tab ${active ? 'Pinned': 'Unpinned'} Successfully`:`Tab Orientation changed to ${active ? 'Vertical': 'Horizontal'} Successfully`)


  } catch (e) {
    const errorMsg = e.response ? e.response.data.message : e.message
    toast.error(`Error: ${errorMsg}`)
  } finally {
    yield put(setDynamicLoading({ loading: false, element }))
  }
}
